module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/interaktivniMapa@3x-062ea6e79011f5e21e0ea6edb17363a8.png";